import type { BiTrackEventType } from '../types';

export const BiTrackRepository = Symbol('BiTrackRepository');

export interface BiTrackRepository {
    biTrack(eventType: string, data: BiTrackEventType): Promise<boolean>;
}
